export default {
  "about.title": "About Us",
  "about.subtitle": "The story and people behind Tennis Club de Douala",
  "about.history": "Our History",
  "about.historyText1": "Founded in the heart of Bonanjo's business district, Tennis Club de Douala has established itself as Cameroon's premier tennis club. Since its creation, the club has continuously grown, evolving from a single court to a 6-court complex meeting international standards.",
  "about.historyText2": "Today, under the presidency of Baby Olivier Pandja, TCD is entering a new era with an ambitious vision: to make the club the tennis hub of Central Africa, host ITF tournaments, and train the next generation of Cameroonian champions.",
  "about.team": "Our Team",
  "about.teamSubtitle": "Passionate professionals dedicated to your progress",
  "about.values": "Our Values",
  "about.valuesExcellence": "Excellence",
  "about.valuesExcellenceDesc": "We aim for the highest standards in everything we do, from court quality to coach training.",
  "about.valuesTraining": "Training",
  "about.valuesTrainingDesc": "We believe in the continuous development of our players, coaches, and staff through internationally recognized training programs.",
  "about.valuesCommunity": "Community",
  "about.valuesCommunityDesc": "TCD is more than a club — it's a family united by passion for tennis and the ambition to make Cameroon shine.",
  "about.valuesInnovation": "Innovation",
  "about.valuesInnovationDesc": "We invest in modern technologies — mobile app, digital booking, connected equipment — for a premium experience.",
  "about.partners": "Partners & Affiliations",
  "about.contactCta": "Want to join us?",
  "about.contactBtn": "Contact Us"
}